import React, { Fragment } from 'react';
import styled from "styled-components";

const Wrapper = styled.div`
    // margin-left: ${props => props.marginLeft || 'auto'};
    // margin-right: ${props => props.marginRight || 'auto'};
    // margin-top: ${props => props.marginTop || 0};
    // margin-bottom: ${props => props.marginBottomWrapper || '40px'};
    // max-width: ${props => props.maxWidth || "100%"};
    // color: ${props => props.color};


    text-align: center;
    color: #FFFFFF;

    ${props => props.theme.mediaQueries.medium}{
        // width: ${props => props.widthMediaQueriesMedium};
        // max-width: ${props => props.maxWidthMediaQueriesMedium};
        // margin-left: 0;
        // margin-right: 0;
        // margin-bottom: ${props => props.marginBottomWrapperMediaQueriesMedium || '40px'};
    }
`;



const Text = styled.p`
    margin-bottom: ${props => props.marginBottom};
    line-height: 22px;
    font-weight: 300;
    color: ${props => props.color};
    font-size: ${props => props.fontSize};

    ${props => props.theme.mediaQueries.medium}{
        font-weight: 300;
        font-size: 0.7rem;
        line-height: 30px;

    }

    a {
        color: ${props => props.color};
        text-decoration: underline;
    }
`

const Footer = ({
    headerText, 
    paragraphText,
    content,
    ...props
}) => {

    const renderText = () => {
        return content.map((item, index) => {
            return (
                <Fragment key={index}>
                    <Text
                        marginBottom ={item.marginBottom}
                        color ={item.color}
                        fontSize ={item.fontSize}

                    >
                        {item.text}
                    </Text>
                </Fragment>
            )
        })
    }
    return (
        <Wrapper {...props}>
            {renderText(content)}
        </Wrapper>
    )
}

export default Footer;